import { Menu, Search } from "lucide-react";
import { Link } from "react-router";

import { useT } from "@/shared/i18n/useT";
import { EstateLockup } from "@/shared/ui/brand/EstateLockup";

/** Below the desktop breakpoint: the rail becomes a menu behind this charcoal bar. */
export function MobileTopbar({
  onOpenMenu,
  onSearch,
}: {
  onOpenMenu: () => void;
  onSearch: () => void;
}) {
  const t = useT();
  const iconButton =
    "grid size-10 place-items-center rounded-xl text-rail-ink-muted transition-colors hover:bg-rail-hover hover:text-rail-ink [&_svg]:size-5";
  return (
    <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-1 bg-rail/95 px-2 pt-[env(safe-area-inset-top)] backdrop-blur lg:hidden">
      <button
        type="button"
        onClick={onOpenMenu}
        aria-label={t("shell.openMenu")}
        className={iconButton}
      >
        <Menu aria-hidden="true" />
      </button>
      <Link to="/" aria-label={t("app.name")} className="flex-1 px-1">
        <EstateLockup tone="dark" />
      </Link>
      <button
        type="button"
        onClick={onSearch}
        aria-label={t("common.search")}
        className={iconButton}
      >
        <Search aria-hidden="true" />
      </button>
    </header>
  );
}
